import {BaseReactController} from "@ok/common/core/engine/controller/BaseReactController";

export class AppController<TStore> extends BaseReactController<TStore> {
}
